// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"8ff2581a","726":"cd125d38","775":"8b97aa7f"}[chunkId] + ".chunk.js";
};